"use strict";

exports.__esModule = true;
exports.MapperDialogForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PartDialogFormWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MapperDialogForm__PartDialogFormWrapper",
  componentId: "sc-lhscvf-0"
})(["display:flex;flex-direction:column;"]);
var DialogBodySection = _styledComponents["default"].div.withConfig({
  displayName: "MapperDialogForm__DialogBodySection",
  componentId: "sc-lhscvf-1"
})(["display:flex;flex-direction:row;margin:8px 16px;"]);
var ExistingValues = _styledComponents["default"].div.withConfig({
  displayName: "MapperDialogForm__ExistingValues",
  componentId: "sc-lhscvf-2"
})([""]);
var LabelWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MapperDialogForm__LabelWrapper",
  componentId: "sc-lhscvf-3"
})(["display:flex;flex-direction:row;"]);
var Label = _styledComponents["default"].div.withConfig({
  displayName: "MapperDialogForm__Label",
  componentId: "sc-lhscvf-4"
})(["font-weight:bold;margin:8px 16px;width:104px;text-align:left;"]);
var Value = _styledComponents["default"].div.withConfig({
  displayName: "MapperDialogForm__Value",
  componentId: "sc-lhscvf-5"
})(["font-weight:bold;margin:8px 16px;"]);
var SubmitButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "MapperDialogForm__SubmitButton",
  componentId: "sc-lhscvf-6"
})(["margin-left:16px;"]);
var MapperDialogForm = exports.MapperDialogForm = function MapperDialogForm(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var label = props.label,
    originalValue = props.originalValue,
    mappedValue = props.mappedValue,
    isSubmitting = props.isSubmitting,
    isDisabled = props.isDisabled,
    _props$inputProps = props.inputProps,
    value = _props$inputProps.value,
    placeholder = _props$inputProps.placeholder,
    onChange = _props$inputProps.onChange,
    onSubmit = props.onSubmit;
  return /*#__PURE__*/_react["default"].createElement(PartDialogFormWrapper, {
    "data-testid": "mapping-dialog-form"
  }, /*#__PURE__*/_react["default"].createElement(ExistingValues, null, /*#__PURE__*/_react["default"].createElement(LabelWrapper, null, /*#__PURE__*/_react["default"].createElement(Label, null, label, ":"), /*#__PURE__*/_react["default"].createElement(Value, {
    "data-testid": "original-value"
  }, originalValue)), /*#__PURE__*/_react["default"].createElement(LabelWrapper, null, /*#__PURE__*/_react["default"].createElement(Label, null, translate("PartDialogForm.mappingLabel", "Mapping"), ":"), /*#__PURE__*/_react["default"].createElement(Value, {
    "data-testid": "mapped-value"
  }, mappedValue))), /*#__PURE__*/_react["default"].createElement(DialogBodySection, null, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
    "data-testid": "input-mapping-value",
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    large: true,
    disabled: isSubmitting || isDisabled
  }), /*#__PURE__*/_react["default"].createElement(SubmitButton, {
    "data-testid": "mapping-submit-button",
    type: "submit",
    intent: _core.Intent.PRIMARY,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "PartDialogForm.button",
      defaultMessage: "Submit"
    }),
    large: true,
    loading: isSubmitting,
    disabled: !value.trim(),
    onClick: onSubmit
  })));
};